<!-- Summary KPIs for the selected period / fixed 12-month report. -->
<template>
    <section class="summary-grid">
        <article class="summary-card">
            <header>
                <h3>Total Bookings</h3>
                <font-awesome-icon icon="fa-solid fa-calendar" class="summary-icon" />
            </header>
            <p class="summary-value">{{ formatInt(summary.totalBookings) }}</p>
        </article>
        <article class="summary-card">
            <header>
                <h3>Total Players</h3>
                <font-awesome-icon icon="fa-solid fa-users" class="summary-icon" />
            </header>
            <p class="summary-value">{{ formatInt(summary.totalPlayers) }}</p>
        </article>
        <article class="summary-card">
            <header>
                <h3>Avg Players/Booking</h3>
                <font-awesome-icon icon="fa-solid fa-users" class="summary-icon" />
            </header>
            <p class="summary-value">{{ summary.avgPlayersPerBooking.toFixed(1) }}</p>
        </article>
        <article v-if="summary.hasLocationRating" class="summary-card">
            <header>
                <h3>{{ summary.ratingLabel || "Avg Location Rating" }}</h3>
                <font-awesome-icon icon="fa-solid fa-star" class="summary-icon" />
            </header>
            <p class="summary-value">{{ summary.avgLocationRating.toFixed(1) }}</p>
        </article>
    </section>
</template>

<script setup>
defineProps({
    summary: {
        type: Object,
        required: true,
    },
});

function formatInt(value) {
    return Number(value || 0).toLocaleString();
}
</script>

<style scoped lang="scss">
@use "../../colors" as *;

.summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.summary-card {
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.04);
    padding: 1rem;

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;

        h3 {
            margin: 0;
            font-size: 0.85rem;
            font-weight: 500;
            color: $color-text-primary;
            display: inline-flex;
            align-items: center;
        }
    }
}

.summary-icon {
    color: $color-text-regular;
    opacity: 0.75;
}

.summary-value {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: #fff;
}

.summary-sub {
    margin: 0.35rem 0 0;
    font-size: 0.75rem;
    color: $color-text-regular;
}
</style>
